import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'; 
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import './index.css';

const AppList = () => {
    const [apps, setApps] = useState([]);
    const [banners, setBanners] = useState([]); 
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate(); 
    const apiUrl = process.env.REACT_APP_API_URL;

    const telegramUserId = localStorage.getItem('telegram_user_id');

    useEffect(() => {
        const fetchApps = async () => {
            try {
                const response = await fetch(`${apiUrl}apps/list/?user_id=${telegramUserId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
        
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
        
                const data = await response.json();
                console.log(data);
                
                setApps(data);
                setLoading(false);
            } catch (err) {
                console.error('Error:', err);
                setError(err.message);
            }
        };

        const fetchBanners = async () => {
            try {
                const response = await fetch(`${apiUrl}apps/adds/`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
        
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
        
                const data = await response.json();
                console.log(data);
                
                setBanners(data);
            } catch (err) {
                console.error('Error fetching banners:', err);
                setError(err.message);
            }
        };

        fetchApps();
        fetchBanners(); 
    }, [apiUrl, telegramUserId]); 

    const handleViewApp = (id) => {
        navigate(`/app/${id}`);
    };

    const handleBannerClick = (url) => {
        if (url) {
            window.location.href = url;
        }
    };

    const truncateHtml = (html, maxLength) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        let truncated = div.textContent || div.innerText || '';
        if (truncated.length > maxLength) {
            truncated = truncated.substring(0, maxLength) + '...';
        }
        return truncated;
    };

    return (
        <div className="app-list">
            <Swiper
                slidesPerView={'auto'}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper"
            >
                {banners.map((banner, index) => (
                    <SwiperSlide 
                        key={index} 
                        onClick={() => handleBannerClick(banner.url)}
                        style={{ cursor: 'pointer' }} 
                    >
                        <img src={`${apiUrl}${banner.image}`} alt={`Banner ${index + 1}`} />
                    </SwiperSlide>
                ))}
            </Swiper>

            <h1>Доступные приложения</h1>

            <div className="section-title">Рекомендуем</div>
            <div className="horizontal-scroll">
                {apps.slice(0, 3).map(app => (
                    <div key={app.id} className="app-item">
                        <img 
                            src={`${apiUrl}${app.icon}`} 
                            alt={`${app.name} icon`} 
                            className="app-icon"
                        />
                        <div className="app-details">
                            <h2>{app.name}</h2>
                            <p dangerouslySetInnerHTML={{ __html: truncateHtml(app.description, 25) }} />
                            <p className="rating">{app.rating} ★</p>
                        </div>
                        <div className="app-action">
                            <FontAwesomeIcon 
                                icon={faArrowRight} 
                                onClick={() => handleViewApp(app.id)} 
                                className="view-app-icon"
                            />
                        </div>
                    </div>
                ))}
            </div>

            <div className="section-title">Специально для вас</div>
            <ul>
                {apps.slice(3).map(app => (                    
                    <li key={app.id} className="app-item">
                        <div className='appListIcon'>
                            <img 
                                src={`${apiUrl}${app.icon}`}
                                alt={`${app.name} icon`} 
                                className="app-icon"
                            />
                        </div>

                        <div className="app-details">
                            <h2>{app.name}</h2>
                            <p dangerouslySetInnerHTML={{ __html: truncateHtml(app.description, 50) }} />
                            <p className="rating">{app.rating} ★</p>
                        </div>
                        <div className="app-action">
                            <FontAwesomeIcon 
                                icon={faArrowRight} 
                                onClick={() => handleViewApp(app.id)} 
                                className="view-app-icon"
                            />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AppList;
